import { createSlice } from '@reduxjs/toolkit';
import {
  getRegions,
  addRegion,
  deleteRegion,
  getRegionById,
  updateRegion,
  filterRegions,
  mergeRegions, // Import the mergeRegions thunk
} from './regionsThunk';

const initialState = {
  regions: [],
  region: null,
  loading: false,
  error: null,
};

const regionsSlice = createSlice({
  name: 'regions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRegions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRegions.fulfilled, (state, action) => {
        state.regions = action.payload;
        state.loading = false;
      })
      .addCase(getRegions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addRegion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addRegion.fulfilled, (state, action) => {
        state.region = true
        state.loading = false;
      })
      .addCase(addRegion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteRegion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteRegion.fulfilled, (state, action) => {
        state.regions = state.regions.filter((region) => region.id !== action.payload); // Corrected filtering
        state.loading = false;
      })
      .addCase(deleteRegion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getRegionById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRegionById.fulfilled, (state, action) => {
        state.region = action.payload;
        state.loading = false;
      })
      .addCase(getRegionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateRegion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRegion.fulfilled, (state, action) => {
        state.regions = state.regions?.map((region) =>
          region.id === action.payload.id ? action.payload : region
        );
        state.loading = false;
      })
      .addCase(updateRegion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(filterRegions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(filterRegions.fulfilled, (state, action) => {
        state.regions = action.payload;
        state.loading = false;
      })
      .addCase(filterRegions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

       // Add reducers for mergeRegions
       .addCase(mergeRegions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(mergeRegions.fulfilled, (state, action) => {
        state.loading = false;
        state.region = action.payload; // Update state with the merged region
        // Optionally, update the regions list to reflect the merge
        state.regions = state.regions.filter(region => !action.payload.regionIds.includes(region.id));
      })
      .addCase(mergeRegions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default regionsSlice.reducer;